#@import swfobject
#@export DetectFlash

window.DetectFlash ?= {}

DetectFlash.hasFlash =
  swfobject.hasFlashPlayerVersion('1')
